/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_2Inputs */

const en_us2_onboarding_parq_2 = /** @type {(inputs: Onboarding_Parq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you feel chest pain when you do physical activity?`)
};

const pt_br2_onboarding_parq_2 = /** @type {(inputs: Onboarding_Parq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você sente dor no peito quando faz atividade física?`)
};

const es_419_onboarding_parq_2 = /** @type {(inputs: Onboarding_Parq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Sientes dolor en el pecho cuando haces actividad física?`)
};

const pt_pt2_onboarding_parq_2 = /** @type {(inputs: Onboarding_Parq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentes dor no peito quando fazes atividade física?`)
};

const fr_fr2_onboarding_parq_2 = /** @type {(inputs: Onboarding_Parq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressens-tu une douleur à la poitrine quand tu fais de l'activité physique ?`)
};

const de_de2_onboarding_parq_2 = /** @type {(inputs: Onboarding_Parq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du Schmerzen in der Brust, wenn du dich körperlich betätigst?`)
};

const it_it2_onboarding_parq_2 = /** @type {(inputs: Onboarding_Parq_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senti dolore al petto quando fai attività fisica?`)
};

/**
* | output |
* | --- |
* | "Do you feel chest pain when you do physical activity?" |
*
* @param {Onboarding_Parq_2Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_2 = /** @type {((inputs?: Onboarding_Parq_2Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_2Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_2(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_2(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_2(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_2(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_2(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_2(inputs)
	return en_us2_onboarding_parq_2(inputs)
});
export { onboarding_parq_2 as "onboarding.parq.2" }